document.addEventListener("turbolinks:load", function (_event) {
  $(".selectize").selectize();
  $("#element-content").trumbowyg({
    lang: "pt_BR",
  });
});
